import { loginRequest } from "./authConfig";
import msalInstance from "./authServiceInstance";
import { tokenManager } from "./tokenManager";

export const acquireToken = async () => {
  try {
    if (!msalInstance) {
      throw new Error("MSAL instance is not initialized and no token available");
    }
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      throw new Error("No accounts found. User needs to sign in.");
    }
    // const response = await msalInstance.acquireTokenSilent(loginRequest);
    // return response.accessToken;
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0],
    });
    tokenManager.setLoginType("azure");
    tokenManager.setTokens(response.accessToken);
    return response.accessToken;
  } catch (error) {
    clearCache(error);
    throw error;
  }
};

const clearAllCookies = () => {
  const cookies = document.cookie.split("; ");
  for (const cookie of cookies) {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
  }
};

const clearBrowserData = () => {
  localStorage.clear();
  sessionStorage.clear();
  indexedDB.deleteDatabase("_msal"); // Specific to MSAL
};

export const clearCache = (error) => {
  clearBrowserData();
  clearAllCookies();
  console.error("Token acquisition failed:", error);
  window.location.href = "/login";
};
